module.exports = __webpack_public_path__ + "img/[加油].0494e587.svg";